import angular from 'angular';
import fundingRequired from './fundingRequired';

export default angular
  .module('fundingDetailsSection.scenes.fundingRequired', [])
  .component('fundingRequired', fundingRequired).name;
